import { Translatable } from '@icc/shared/helpers';

export class BoxConnector {
    id: number;
    @Translatable({ model: 'WindowAccessories' })
    name: string;
    indexNo: string | null;
    extId: string | null;
    weight: number | null;
    order: number | null;
    blindBoxTypesIds: number[] | null;
    leftSegmentId?: number | null;
    rightSegmentId?: number | null;
}
